// Woods and sheet goods. `color`/`grain` drive the procedural texture in the viewer;
// `density` (kg/m³, air-dry) gives the weight; `hard` picks the dovetail slope (1:8 vs 1:6);
// `sheet` marks panel goods that are bought as whole sheets (no grain direction to respect
// across the width, nested on `stock` in the cut plan).

export const MATERIALS = [
  { id: 'kiefer', name: 'Kiefer', color: '#dcb47c', grain: '#b98a50', density: 520, hard: false },
  { id: 'fichte', name: 'Fichte', color: '#e6cc9c', grain: '#c9a46a', density: 470, hard: false },
  { id: 'buche', name: 'Buche', color: '#d9a678', grain: '#bf8659', density: 720, hard: true },
  { id: 'eiche', name: 'Eiche', color: '#bf9161', grain: '#94683d', density: 690, hard: true },
  { id: 'esche', name: 'Esche', color: '#dcc49b', grain: '#a88b5e', density: 690, hard: true },
  { id: 'ahorn', name: 'Ahorn', color: '#ead8b6', grain: '#d3bb91', density: 650, hard: true },
  { id: 'kirsche', name: 'Kirsche', color: '#b26a45', grain: '#8c4d2e', density: 600, hard: true },
  { id: 'nuss', name: 'Nussbaum', color: '#73503a', grain: '#4f3424', density: 640, hard: true },
  { id: 'mpx', name: 'Birke Multiplex', color: '#e4d1a8', grain: '#cdb486', density: 680, hard: true, sheet: true, stock: [2500, 1250] },
  { id: 'sperrholz', name: 'Pappel-Sperrholz', color: '#dcc497', grain: '#c4a877', density: 450, hard: false, sheet: true, stock: [2500, 1220] },
  { id: 'mdf', name: 'MDF', color: '#b9a07c', grain: '#b09673', density: 750, hard: false, sheet: true, stock: [2800, 2070], noGrain: true },
  { id: 'hdf', name: 'HDF (Rückwand)', color: '#8c7051', grain: '#816548', density: 850, hard: false, sheet: true, stock: [2800, 2070], noGrain: true },
]

export const MATERIAL = Object.fromEntries(MATERIALS.map((m) => [m.id, m]))
export const materialOf = (id) => MATERIAL[id] || MATERIAL.eiche

// Bought parts: look only, they are listed under "Einkauf" and never cut.
export const HW_KINDS = {
  fassung: { name: 'Fassung E27', finish: 'messing', D: 40, L: 62 },
  birne: { name: 'Leuchtmittel (Globe)', finish: 'glas', D: 95 },
  kabel: { name: 'Textilkabel', finish: 'textil', D: 6, L: 800 },
  baldachin: { name: 'Baldachin', finish: 'schwarz', D: 100, L: 25 },
  diffusor: { name: 'Diffusor (Opal)', finish: 'opal', D: 420, L: 3 },
  led: { name: 'LED-Modul', finish: 'led', D: 300, L: 12 },
  ledstrip: { name: 'LED-Streifen 24 V', finish: 'led', L: 300, W: 10, T: 2 },
  platte: { name: 'Diffusor-Platte (opal)', finish: 'opal', L: 300, W: 150, T: 2 },
  box: { name: 'Kaufteil', finish: 'schwarz', L: 60, W: 40, T: 20 },
}

export const FINISHES = {
  messing: { color: '#c9a45c', metalness: 0.85, roughness: 0.32 },
  schwarz: { color: '#232422', metalness: 0.3, roughness: 0.6 },
  textil: { color: '#3a3b38', metalness: 0, roughness: 0.95 },
  glas: { color: '#fff4dc', metalness: 0, roughness: 0.15, emissive: '#ffd89a' },
  opal: { color: '#f2f1ee', metalness: 0, roughness: 0.6, emissive: '#fff0d8', opacity: 0.94 },
  led: { color: '#dcdcd8', metalness: 0.2, roughness: 0.5, emissive: '#fff3e2' },
}
